
import React from 'react';
import { Row, Dropdown, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TableSearchInput from './TableSearchInput';
import Store from '../store/Store';
import '../css/taskfilterbar.css'

const TaskFilterBar = ({ searchKey, setSearchKey, order, setOrder, isDoneFilter, setIsDoneFilter }) => {
  const { user } = Store.getState(); 
  return (
    <Row className='search-filter-container mb-2'>
      <div className="col-10">
        <TableSearchInput keyword={searchKey} setKeyword={setSearchKey} />
      </div>
      <div className="filter">
        <Row>
          <Dropdown className="custom-dd dd-smallbtn">
            <Dropdown.Toggle className={`button ${isDoneFilter ? 'active-filter' : ''}`} id="dropdown-custom" variant="">
              {/* <FontAwesomeIcon icon={'gear'} /> Szűrés */}
              <FontAwesomeIcon icon={'gears'} />
            </Dropdown.Toggle>

            <Dropdown.Menu className='p-2'>
              <Dropdown.Item onClick={() => setOrder(1)} className={`fake-radio ${order === 1 ? 'selected' : ''}`}>
                Kezdés időpontja szerint növekvő
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setOrder(0)} className={`fake-radio ${order === 0 ? 'selected' : ''}`}>
                Kezdés időpontja szerint csökkenő
              </Dropdown.Item>
                {user?.permissions?.includes('pwaViewCompletedTasks') && (
                  <Dropdown.Item>
                    <Form.Check
                      type="checkbox"
                      label='Elvégzett feladatok elrejtése'
                      checked={isDoneFilter}
                      onChange={() => setIsDoneFilter(prev => !prev)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Dropdown.Item>
                )}
            </Dropdown.Menu>
          </Dropdown>
        </Row>
      </div>
    </Row>
  );
};

export default TaskFilterBar;
